export const taskState = (task) => {
  if (task.status === "done") return "done";
  if (task.status === "overdue") return "overdue";
  return "open";
};

export const isInternalTask = (task) => Boolean(task.internal);

const matchers = {
  all: () => true,
  opendate: (task) => isInternalTask(task),
  overdue: (task) => taskState(task) === "overdue",
  completed: (task) => taskState(task) === "done",
};

export const filterGroups = (groups, filter) => {
  if (filter === "all") return groups;

  const matches = matchers[filter];
  return groups
    .map((group) => ({ ...group, tasks: group.tasks.filter(matches) }))
    .filter((group) => group.tasks.length > 0);
};
